import { createSlice } from "@reduxjs/toolkit";

//Sliceの作成
export const conflictSlice = createSlice({
    name: "conflict",
    initialState: {
        conflictObj: [],
        ownStoreType: {},
        actualCommercialArea: {
            numOfHouseholds_5minuteWalkFromCommercialArea: "",
            households: "0",
            numOfHouseholds_ActualCommercialArea: "",
            numOfEmployees_5minuteWalkFromCommercialArea: "",
            employees: "0",
            numOfEmployees_ActualCommercialArea: "",
        },
        market_cut: {
            plan_area_id: "",
            branch: "",
            create_date: "",
            update_date: "",
            delete_flag: "",
            households: "",
            employees: "",
            excel_path: "",
            market_cut_img_path: "",
            market_cut_basis_img_path: "",
            approval_confirm_flag: "",
            approval_confirm_user: "",
            approval_confirm_department: "",
            approval_confirm_date: "",
            approval_confirm_stamp: "",
            approval_research_mgr_flag: "",
            approval_research_mgr_user: "",
            approval_research_mgr_department: "",
            approval_research_mgr_date: "",
            approval_research_mgr_stamp: "",
            approval_research_gm_flag: "",
            approval_research_gm_user: "",
            approval_research_gm_department: "",
            approval_research_gm_date: "",
            approval_research_gm_stamp: "",
            approval_mgr_flag: "",
            approval_mgr_user: "",
            approval_mgr_department: "",
            approval_mgr_date: "",
            approval_mgr_stamp: "",
            approval_gm_flag: "",
            approval_gm_user: "",
            approval_gm_department: "",
            approval_gm_date: "",
            approval_gm_stamp: "",
            cut_market: "",
        },
    },

    //toolKitを利用した値変更処理
    reducers: {
        setConflict: (state, action) => {
            state.conflictObj = action.payload;
        },
        setOwnStoreType: (state, action) => {
            state.ownStoreType = action.payload;
        },
        setActualCommercialArea: (state, action) => {
            state.actualCommercialArea = action.payload;
        },
        setMarketCut: (state, action) => {
            state.market_cut = action.payload;
        },
    },
});

export const { setConflict, setOwnStoreType, setActualCommercialArea, setMarketCut } =
    conflictSlice.actions;
export default conflictSlice.reducer;
